export function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
        images[item.replace('./', '')] = r(item);
        return null;
    });
    return images;
}


// WEBPACK FOOTER //
// ./src/utils/images.js